// extracted by mini-css-extract-plugin
export default {"content":"styles_content__N47Pv","plate":"styles_plate__PcUY0","errorText":"styles_errorText__Wtb0j"};